const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2023 - 2024",
    title: "Thinkful Software Engineering Bootcamp",
    desc: "Acquired comprehensive knowledge of industry best practices and software development standards, focusing on JavaScript, HTML5, CSS3, React Native, Node.js, PostgreSQL, RESTful APIs, algorithms, and data structures.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2021-2022",
    title: "University of California, Riverside",
    desc: "Master's Degree, M.Ed.",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2018-2021",
    title: "University of California, Riverside",
    desc: "B.A, Bachelor's in Learning and Behavioral Studies",
  },

  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2025 - Current",
    title: "Lead Software Engineer/Tech Lead | GetOutlier",
    desc: "Leading IT Solutions and Engineering for ballistics businesses. Utilizing Python and Django for backend development, and React for frontend interfaces. Overseeing project management, team coordination, and ensuring the delivery of high-quality software solutions tailored to inventory management, SEO improvement and web development needs.",
  },

  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - 2025",
    title: "Software Engineer - FrontEnd | ComplyAI",
    desc: "Develop and enhance web applications using TypeScript, JavaScript, React, and TailwindCSS. Focus on creating intuitive, user-friendly interfaces that improve the overall user experience.Build efficient, accessible, and responsive web applications optimized for performance.Implement modern front-end development practices, ensuring clean, maintainable code.Collaborate closely with cross-functional teams to deliver high-quality solutions that address real-world problems.Continuously seek ways to improve the user experience and technical quality of web applications.",
  },

  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - Current",
    title: "Fullstack Software Engineering Intern (AI) | The Madden Academy",
    desc: "Collaborate in a dynamic team to develop an AI chatbot using PHP/Laravel and JavaScript. Implementing and integrating Natural Language Models (NLM) to enhance the chatbot's ability to coach users through Madden games. Participating in designing, coding, testing, and deploying chatbot features to ensure a seamless user experience.",
  },
];

export default Data;
